import { FC } from 'react';
import { useModalStore } from '../stores/modalStore';
import SuccessModal from './SuccessModal';
import ErrorModal from './ErrorModal';
import ConfirmModal from './ConfirmModal';

const ModalProvider: FC = () => {
  const { isOpen, type, props, closeModal } = useModalStore();

  if (!isOpen || !type || !props) {
    return null;
  }

  const renderModal = () => {
    switch (type) {
      case 'success': {
        const successProps = props as { message: string; title?: string; details?: string[] };
        return (
          <SuccessModal
            isOpen={isOpen}
            onClose={closeModal}
            message={successProps.message}
            title={successProps.title}
            details={successProps.details}
          />
        );
      }
      case 'error': {
        const errorProps = props as { message: string; title?: string };
        return (
          <ErrorModal
            isOpen={isOpen}
            onClose={closeModal}
            message={errorProps.message}
            title={errorProps.title}
          />
        );
      }
      case 'confirm': {
        const confirmProps = props as {
          message: string;
          onConfirm: () => void;
          title?: string;
          confirmLabel?: string;
          cancelLabel?: string;
        };
        return (
          <ConfirmModal
            isOpen={isOpen}
            onClose={closeModal}
            onConfirm={confirmProps.onConfirm}
            message={confirmProps.message}
            title={confirmProps.title}
            confirmLabel={confirmProps.confirmLabel}
            cancelLabel={confirmProps.cancelLabel}
          />
        );
      }
      default:
        return null;
    }
  };

  return renderModal();
};

export default ModalProvider;
